import { render, staticRenderFns } from "./NutritionReport.vue?vue&type=template&id=60310653&"
import script from "./NutritionReport.vue?vue&type=script&lang=js&"
export * from "./NutritionReport.vue?vue&type=script&lang=js&"
import style0 from "./NutritionReport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports